module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iter-step.js
// module id = ./node_modules/core-js/library/modules/_iter-step.js
// module chunks = 0 1 2